import React from "react"
import Image from "../UI/Image/Image"
import Link from "../UI/Link/Link"
import PropTypes from "prop-types"
import * as style from "./ProductSlider-tw-styles"

const ProductSliderCard = props => {
  const { image, keyValue, link } = props
  const styles = style?.ProductSliderCardsStyles
  return (
    <div className={styles?.slickSlide} key={keyValue}>
      <Link
        label={
          <Image
            {...image?.imageDesktop}
            className={styles?.slickSlideImage}
            src={image.imageDesktop.url}
            alt={image?.imageDesktop?.altText || image.altText}
          />
        }
        {...link}
        url={link?.url}
      />
    </div>
  )
}

ProductSliderCard.propTypes = {
  image: PropTypes.object,
  keyValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  link: PropTypes.object,
}
export default ProductSliderCard
